import { Component, OnInit, Input, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { ParametersService } from '../../service/parameters.service';
import { Style } from '../../model/settings.model';
import { RoiAnalysis } from '../../model/damage.model';
import { fabric } from 'fabric_gesture';

@Component({
  selector: 'app-canvas-imageprocessing',
  templateUrl: './canvas-imageprocessing.component.html',
  styleUrls: ['./canvas-imageprocessing.component.less']
})
export class CanvasImageprocessingComponent implements OnChanges {


  private canvas: fabric.Canvas;
  @Input() result: { heatmap: string,  url?: string, b64?: string };
  @Input() opacityH: number
  @Input() opacityP: number
  @Input() opacityC: number
  image
  heatmap
  parts
  car

  constructor(private readonly _parametersService: ParametersService) {
  }

  getImageDimensions(file) {
    return new Promise(function (resolved, rejected) {
      var i = new Image()
      i.onload = function () {
        resolved({ width: i.width, height: i.height })
      };
      i.src = file
    })
  }


  private resizeCanvas() {
    const container = document.getElementById('canvasContainer').getBoundingClientRect()
    console.log('Resize : ', container);
    this.canvas.setHeight(container.height);
    this.canvas.setWidth(container.width);
  }

  renderCanvas() {
    if (this.result.b64)
      this.getImageDimensions('data:image/jpg;base64,' + this.result.b64).then((size: { width: number, height: number }) => {
        let myImage = new Image(size.width, size.height);
        myImage.src = 'data:image/jpg;base64,' + this.result.b64
        this.image = new fabric.Image(myImage);
        if (!this.result.heatmap) {
          this.addImage(this.image)
        }
        this.createResult(size)
      })
    else if (this.result.url) {
      fabric.Image.fromURL(this.result.url, image => {
        this.image = image
        this.addImage(this.image)
        this.createResult({ width: this.image.getOriginalSize().width, height: this.image.getOriginalSize().height })
      }, { crossOrigin: 'Anonymous' });
    }
  }

  createResult(size: { width: number, height: number }) {

   

    if (this.result.heatmap) {
      let myHeatmap = new Image(size.width, size.height);
      myHeatmap.src = 'data:image/jpg;base64,' + this.result.heatmap
      console.log("sbe2",this.result.heatmap)
      this.heatmap = new fabric.Image(myHeatmap);
      this.addImage(this.heatmap)
    }
  }

  addImage(file) {
    if (this.canvas === undefined || file === undefined) return
    file.selectable = false;
    file.selection = false;
    this.canvas.setZoom(1);
    if (this.canvas.getWidth() * file.getOriginalSize().height > file.getOriginalSize().width * this.canvas.getHeight())
      file.scaleToHeight(this.canvas.getHeight());
    else
      file.scaleToWidth(this.canvas.getWidth());
    this.canvas.add(file)
    file.center();
    file.set({
      left: 0
    });
    file.setCoords();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.result) {
      this.canvas = new fabric.Canvas('fabricCanvas', {
        //  backgroundColor: '#c0dfea',
        selection: false,
      });
      this.canvas.defaultCursor = 'move';
      this.resizeCanvas()
      window.addEventListener('resize', this.resizeCanvas.bind(this), false);
      this.gestureFabric()
      this.image = undefined
      this.heatmap = undefined
      this.parts = undefined
      this.car = undefined
      if (this.canvas)
        this.canvas.clear()
      this.resetView()
      this.renderCanvas()
    }

    if (changes.opacityH && this.heatmap && this.opacityH) {
      this.heatmap.set({ opacity: this.opacityH })
      this.canvas.renderAll();
    }
    if (changes.opacityP && this.parts && this.opacityP) {
      this.parts.set({ opacity: this.opacityP })
      this.canvas.renderAll();
    }

    if (changes.opacityC && this.car && this.opacityC) {
      this.car.set({ opacity: this.opacityC })
      this.canvas.renderAll();
    }

  }

  resetView() {
    if (this.canvas === undefined) return;
    this.canvas.setZoom(1);
    this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    this.canvas.requestRenderAll();
  }

  private gestureFabric() {
    // For zoom on image
    let zoomStartScale
    this.canvas.on('touch:gesture', function (opt) {
      if (opt.e.touches && opt.e.touches.length === 2) {
        var point = new fabric.Point(opt.self.x, opt.self.y);
        if (opt.self.state == "start") {
          zoomStartScale = this.getZoom();
        }
        var delta = zoomStartScale * opt.self.scale;
        this.zoomToPoint(point, delta);
      }
    });
    this.canvas.on('mouse:wheel', function (opt) {
      const delta = -opt.e.deltaY;
      let zoom = this.getZoom();
      zoom *= 1 + delta / 200;
      if (zoom > 20) zoom = 20;
      if (zoom < 1) zoom = 1;
      this.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    // For move canvas
    this.canvas.on('mouse:down', (opt) => {
      const evt = opt.e;
      this.canvas.lastPosX = evt.clientX;
      this.canvas.lastPosY = evt.clientY;
      this.canvas.requestRenderAll();
    });

    this.canvas.on('touch:drag', (opt) => {
      const e = opt.e;
      if (e.type === 'mousemove') {
        const e = opt.e;
        this.canvas.viewportTransform[4] += e.clientX - this.canvas.lastPosX;
        this.canvas.viewportTransform[5] += e.clientY - this.canvas.lastPosY;
        this.canvas.requestRenderAll();
        this.canvas.lastPosX = e.clientX;
        this.canvas.lastPosY = e.clientY;
      } else if (e.type === 'touchmove' && opt.e.touches.length === 1) {
        let currentX = e.touches[0].clientX;
        let currentY = e.touches[0].clientY;
        let xChange = currentX - this.canvas.lastPosX;
        let yChange = currentY - this.canvas.lastPosY;
        if ((Math.abs(currentX - this.canvas.lastPosX) <= 50)
          && (Math.abs(currentY - this.canvas.lastPosY) <= 50)) {
          var delta = new fabric.Point(xChange, yChange);
          this.canvas.relativePan(delta);
        }
        this.canvas.lastPosX = e.touches[0].clientX;
        this.canvas.lastPosY = e.touches[0].clientY;
        this.canvas.setCursor(this.canvas.defaultCursor);
      } else if (e.type === 'touchmove' && opt.e.touches.length === 3) {
        this.resetView()
      }
    });

    this.canvas.on('mouse:dblclick', (e: fabric.IEvent) => { this.resetView() });

  }



}



// WEBPACK FOOTER //
// ./src/app/detection/canvas-imageprocessing/canvas-imageprocessing.component.ts